import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Module-level cache so the SEO settings only round-trip once per app load
// even if multiple SEOHead / JsonLd instances mount across page navigations.
let cachedPromise = null;
let cachedValue = null;

const fetchOnce = () => {
  if (cachedValue) return Promise.resolve(cachedValue);
  if (cachedPromise) return cachedPromise;
  cachedPromise = axios
    .get(`${API_URL}/seo/settings`)
    .then((res) => {
      cachedValue = res.data || {};
      return cachedValue;
    })
    .catch(() => {
      cachedValue = {};
      return cachedValue;
    })
    .finally(() => { cachedPromise = null; });
  return cachedPromise;
};

/**
 * useSeoSettings — small hook that returns the site-wide SEO config
 * fetched from `/api/seo/settings`. Cached app-wide so each page mount
 * doesn't re-hit the network. Returns `{}` while the first fetch is in
 * flight (the SEOHead component handles that gracefully).
 */
const useSeoSettings = () => {
  const [settings, setSettings] = useState(cachedValue || {});
  useEffect(() => {
    let alive = true;
    fetchOnce().then((v) => { if (alive) setSettings(v); });
    return () => { alive = false; };
  }, []);
  return settings;
};

export default useSeoSettings;
